// extracted by mini-css-extract-plugin
export default {"showcase":"PageProduct_showcase__B7Hu-","brand":"PageProduct_brand__75U2V"};